import { FILTERS_TYPES, TFilterField } from '../../constants/filters';
import { EDealType } from '../../utils/jsonQuery';

export function getFiltersList(dealType: EDealType): TFilterField[] {
  return FILTERS_TYPES[dealType] || [];
}
